<template>
    <div class="relative w-full h-2">
        <div class="bg-black opacity-20 w-full h-full"></div>
        <div class="bg-pink w-0 h-full ease-linear absolute top-0 left-0 z-10" :key="`slide-${currentSlideNumber}`" :style="`transition-duration: ${durationCssString}`" :class="timerWidthClass"></div>
    </div>
</template>

<script>
export default {
    name: "AtomCarouselLoadingBar",
    props: {
        currentSlideNumber: {
            type: Number,
            required: true,
        },
        durationCssString: {
            type: String,
            required: true,
        },
        timerWidthClass: {
            type: String,
            required: true,
        }
    }
}
</script>
